export default __webpack_public_path__ + "static/back-8355ff58717f7e082b0a3fa35f958056.jpg";